export default function Tooltip() {
  return (
    <div
      className="axa-icon-icon-tooltip"
      dangerouslySetInnerHTML={{
        __html: `
          <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="14.5" viewBox="0 0 15.5 14.5">
            <g id="Group_21_Copy_8" data-name="Group 21 Copy 8" transform="translate(0.75 0.75)">
              <g id="Group_11_Copy_2" data-name="Group 11 Copy 2">
                <g id="Group_13" data-name="Group 13">
                  <path id="Oval" d="M7,0a6.764,6.764,0,0,1,7,6.5A6.764,6.764,0,0,1,7,13,6.764,6.764,0,0,1,0,6.5,6.764,6.764,0,0,1,7,0Z" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="1.5"/>
                </g>
              </g>
              <path id="Fill_1" data-name="Fill 1" d="M1.077,7H0V2H1.077V7ZM.538,1A.553.553,0,0,1,.157.862.458.458,0,0,1,0,.5.457.457,0,0,1,.157.138.557.557,0,0,1,.538,0,.553.553,0,0,1,.924.138.467.467,0,0,1,1.077.5.469.469,0,0,1,.924.862.549.549,0,0,1,.538,1Z" transform="translate(6.462 3)" stroke="#000" stroke-miterlimit="10" stroke-width="0.5"/>
            </g>
          </svg>
        `,
      }}
    />
  )
}
